<template>
    <div class="container full-width">
        <div class="text-subtitle1">Promotion code</div>
        <q-input
            debounce="200"
            :value="text"
            @input="onChange"
            @blur="onBlur"
            class="bg-white"
            placeholder="Enter promotion code"
            dense
            outlined
            clearable
        />
    </div>
</template>

<script>
export default {
    name: "CommendToShoppers",
    computed: {
        text() {
            return this.$store.state["checkout"]["couponCode"];
        },
    },
    methods: {
        onChange(text) {
            this.$store.commit("checkout/setCouponCode", text);
        },
        onBlur() {
            this.$store.dispatch("checkout/getCost");
        },
    },
};
</script>

<style scoped>
.container {
    padding: 0px 8px;
}
</style>
